import { PermissionKey } from '@client/api';
import { useAgreementPermissions } from '../../hooks/useAgreementPermissions/useAgreementPermissions';
import { Button, ButtonProps, InfoTooltip } from '@client/toolkit';

export interface AgreementPermissionBasedActionButtonProps extends Omit<ButtonProps, 'ref'> {
  agreementId: string;
  permissions: PermissionKey[];
  title?: string;
  disabledTooltip?: string;
}

export function AgreementPermissionBasedActionButton({
  agreementId,
  permissions,
  color = 'primary',
  title,
  children,
  disabled,
  disabledTooltip,
  ...props
}: AgreementPermissionBasedActionButtonProps) {
  const { hasPermission } = useAgreementPermissions({ id: agreementId });
  if (!hasPermission(permissions)) return null;

  const button = (
    <Button color={color} disabledVariant="dark" size="sm" disabled={disabled} {...props}>
      {title ?? children}
    </Button>
  );

  if (disabled && disabledTooltip) {
    return (
      <InfoTooltip message={disabledTooltip} inline>
        <span>{button}</span>
      </InfoTooltip>
    );
  }

  return button;
}
